import { render } from "./GuidesPage.vue?vue&type=template&id=86b90462"
import script from "./GuidesPage.vue?vue&type=script&lang=js"
export * from "./GuidesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__